import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { UnitsOfMeasureView } from '@/features/units-of-measure/units-of-measure'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/products/units-of-measure')({
  validateSearch: z.object({ showHidden: z.boolean().optional() }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'unit_of_measure.view')) {
      throw redirect({ to: '/products' })
    }
  },
  component: UnitsOfMeasureView,
})
